"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crypto = void 0;
const tslib_1 = require("tslib");
const crypto_js_1 = tslib_1.__importDefault(require("crypto-js"));
exports.Crypto = {
    encrypt: (data, encryptionKey) => {
        const iv = crypto_js_1.default.lib.WordArray.random(8);
        const cipherKey = crypto_js_1.default.SHA3(encryptionKey, { outputLength: 256 });
        const encryption = crypto_js_1.default.AES.encrypt(JSON.stringify(data), cipherKey, {
            iv,
        });
        const encryptedData = encryption.toString();
        return `${iv.toString()}-${encryptedData}`;
    },
    decrypt: (encryptedData, encryptionKey) => {
        const cipherKey = crypto_js_1.default.SHA3(encryptionKey, { outputLength: 256 });
        const iv = encryptedData.split("-")[0];
        const cipherText = encryptedData.split("-")[1];
        const decryptedData = crypto_js_1.default.AES.decrypt(cipherText, cipherKey, {
            iv: crypto_js_1.default.enc.Hex.parse(iv),
        });
        const formattedDecryptedData = JSON.parse(decryptedData.toString(crypto_js_1.default.enc.Utf8));
        return formattedDecryptedData;
    },
};
//# sourceMappingURL=Crypto.js.map